import $ from "jquery";

export const search = () => {
  $(".search-results .input-action").on("click", function () {
    const input = $(this).closest(".input-wrap").find("input");
    input.prop("checked", !input.prop("checked"));
    $(this).toggleClass("checked");

    // Initialize an array to hold the values of all checked inputs
    let checkedValues = [];

    // Loop through all checked .input-action elements and gather their data-url-param values
    $(".search-results .input-action.checked").each(function () {
      const value = $(this)
        .closest(".input-wrap")
        .find("input")
        .attr("data-url-param");
      if (value) {
        checkedValues.push(value);
      }
    });

    // Get the current URL and its search parameters
    const url = new URL(window.location);
    const params = url.searchParams;

    // Update the 'vt' parameter with the concatenated string of checked values
    // If no values are checked, remove the 'vt' parameter
    if (checkedValues.length > 0) {
      params.set("vt", checkedValues.join(","));
    } else {
      params.delete("vt");
    }

    // Update the browser's URL without reloading the page
    window.history.replaceState({}, "", `${url.pathname}?${params}`);
    filterSearchResults(); // Call the filterSearchResults function
  });

  $('input[name="s"]').on("keyup", function (e) {
    if (e.key === "Enter") {
      filterSearchResults();
    }
  });

  $(".search-row-container button").on("click", function () {
    filterSearchResults();
  });

  const filterSearchResults = () => {
    const filters = {};

    $(".search-sidebar-inner p").each(function () {
      const label = $(this).find("label");
      const inputAction = $(this).find(".input-action");
      if (!label.hasClass("heading") && inputAction.hasClass("checked")) {
        const parent = $(this)
          .find("input")
          .data("parent")
          .toLowerCase()
          .replace(/ /g, "_");
        filters[parent] = filters[parent] || [];
        filters[parent].push($(this).find("input").val());
      }
    });

    var postcode = $("#ps_search").val(); // Making sure it's this field we are pulling from

    $(".results-meta h2").html("Venues Best Matching:  " + postcode);

    // Show the loading icon
    $(".loading-icon").show();
    $(".results-container").html("");

    $.ajax({
      url: "/admin/wp-admin/admin-ajax.php",
      method: "POST",
      data: {
        postcode: postcode,
        filters,
        action: "filter_search_results",
      },
      success: (res) => {
        // Hide the loading icon
        $(".loading-icon").hide();

        const results = res.venues;

        if (Array.isArray(results) && results.length > 0) {
          let html = results
            .map(
              (val, index) => `
          <div class="venue" data-distance="${val.distance}" data-title="${
                val.post_title
              }">
            <div class="venue-image" style="background: ${
              val.image
                ? `url('${val.image}') no-repeat center / cover;`
                : `#f5efe6;`
            }">
              <div class="title-overlay">${val.short_title}</div>
            </div>
            <div class="venue-info">
              <h3>${val.post_title}</h3>
              <p>${val.post_excerpt}</p>
              <div class="btn-container">
              ${
                val.book_now_widget
                  ? `<button class="btn-primary btn-book-now-venue" data-modal-target="modal-${index}" data-venue-id="${val.ID}">Book Now</button>
                      ${window.etmBookingModalEnabled ? '' : 
                      `<div class="booking-widget modal-widget">
                        <div class="container">
                          <div class="modal fade" id="modal-${index}" tabindex="-1" role="dialog" aria-labelledby="bookingWidgetModal" aria-hidden="true">
                            <div class="modal-dialog" role="document">
                              <div class="modal-content">
                                <div class="modal-header">
                                  <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                  </button>
                                </div>
                                <div class="modal-body">
                                  ${val.book_now_widget}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>`}`
                  : ""
              }
                <a class="btn-default" href="/venues/${
                  val.post_name
                }">View venue</a>
              </div>
            </div>
          </div>`
            )
            .join("");

          $("#count").text(
            `${results.length} result${results.length === 1 ? "" : "s"}`
          );
          $(".results-container").html(html);
          $(".select-container").show();

          /** Use res.searchByPostcode to set the sort correctly */
          if (res.searchByPostcode) {
            $(".results-meta select").val("dn");
          } else {
            $(".results-meta select").val("az");
          }
        } else {
          $("#count").text("0 results");
          $(".results-container").html(res);
          $(".select-container").hide();
        }
      },
      error: () => {
        // Hide the loading icon in case of an error as well
        $(".loading-icon").hide();
        $("#count").text("Error loading results");
        $(".results-container").html(
          "<p>Error loading results. Please try again.</p>"
        );
        $(".select-container").hide();
      },
    });
  };

  $(document).on("change", ".results-meta select", function () {
    const sort = $(".results-meta select option:selected").val();
    const resultsContainer = $(".results-container");
    let venues = resultsContainer.children(".venue");

    const sortFunctions = {
      az: (a, b) =>
        $(a)
          .data("title")
          .toLowerCase()
          .localeCompare($(b).data("title").toLowerCase()),
      za: (a, b) =>
        $(b)
          .data("title")
          .toLowerCase()
          .localeCompare($(a).data("title").toLowerCase()),
      dn: (a, b) =>
        parseFloat($(a).data("distance")) - parseFloat($(b).data("distance")),
      df: (a, b) =>
        parseFloat($(b).data("distance")) - parseFloat($(a).data("distance")),
    };

    if (sortFunctions[sort]) {
      venues.sort(sortFunctions[sort]);
    }

    resultsContainer.append(venues);
  });

  $(".search-sidebar-toggle i, .close-filters").on("click", function () {
    $(".search-sidebar-toggle i").toggleClass("fa-angle-down fa-angle-up");
    $(".search-sidebar-inner").toggle();
  });

  $('.venue-search input').on('keyup', function(e) {
    if (e.keyCode === 13) {
      window.location.href = '/venues/' + $(this).val();
    }
  });

  $('.venue-search button').on('click', function(e) {
    window.location.href = '/venues/' + $(this).closest('.venue-search').find('input').val();
  });
};
